export default __webpack_public_path__ + "media/images/lp/conversion-main-pc-6f1e310c6bac9d99ac4c86e92afa3cd6.png";